import { render, staticRenderFns } from "./CardCustomHeader.vue?vue&type=template&id=2591730a&"
import script from "./CardCustomHeader.vue?vue&type=script&lang=js&"
export * from "./CardCustomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports